import { render, staticRenderFns } from "./InfoStatistic.vue?vue&type=template&id=f3395144&scoped=true"
import script from "./InfoStatistic.vue?vue&type=script&lang=js"
export * from "./InfoStatistic.vue?vue&type=script&lang=js"
import style0 from "./InfoStatistic.vue?vue&type=style&index=0&id=f3395144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3395144",
  null
  
)

export default component.exports